'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('../css/PagingButton.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prefer-stateless-function */


/*
Pflichtproperties:
Id={"pbBack"+this.state.id} 
onClick={()=>{ this.Previous(this)}} 
text={}                                            

optional:
Type={"Picker"}
Width={30} 
Tooltip={}
*/

var PagingButton = function (_Component) {
    _inherits(PagingButton, _Component);

    function PagingButton() {
        _classCallCheck(this, PagingButton);

        return _possibleConstructorReturn(this, (PagingButton.__proto__ || Object.getPrototypeOf(PagingButton)).apply(this, arguments));
    }

    _createClass(PagingButton, [{
        key: 'render',
        value: function render() {
            var controllClass = '';
            if (!this.props.Type) {
                controllClass = "pagingButton";
            } else if (this.props.Type === "Picker") {
                controllClass = "pagingButtonPicker";
            }

            var Style = null;
            if (this.props.Width) {
                Style = { width: this.props.Width, height: this.props.Width };
            }
            var text = this.props.text;

            var Tooltip = '';
            if (this.props.Tooltip) {
                Tooltip = _react2.default.createElement(
                    'span',
                    null,
                    this.props.Tooltip
                );
            }

            return _react2.default.createElement(
                'div',
                {
                    className: controllClass,
                    style: Style,
                    onClick: this.props.onClick },
                text,
                Tooltip
            );
        }
    }]);

    return PagingButton;
}(_react.Component);

exports.default = PagingButton;